<template>
    <div class="checklist-item d-flex flex-nowrap">
        <span class="text-xl text-green-light" :class="listIcon"></span>
        <p class="px-3">
            <slot></slot>
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            icon: { type: String, required: false },
        },

        computed: {
            listIcon: function () {
                if ( !this.icon ) {
                    return 'icon-check';
                }

                return 'icon-' + this.icon;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ChecklistItem.vue